import { auth } from 'pages/components/AuthShell/AuthShell.styled';
import styled from 'styled-components';

export const PageForm = styled.div`
  width: 100%;
  font-family: ${auth.font};
`;

export const ModalCard = styled.div`
  width: min(92vw, 420px);
  padding: 28px;
  background: ${auth.card};
  border-radius: 16px;
  border: 1px solid ${auth.line};
  box-shadow: 0 24px 60px -28px rgba(46, 10, 79, 0.4);
  font-family: ${auth.font};
  color: ${auth.text};
`;
